<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- Completed exams -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">{{title}}</span>
                </div>
              </b-col>
              <b-col cols="12">
                  <span class="txt-section-subtitle red">Completed exams: {{totalRows | prettyNumber}}</span>
              </b-col>
            </b-row>
          </div>

          <div v-if="cntWebinars==0 && cntPodcasts==0" class="div-section-body">
              No CE completed.
          </div>
          <div v-else>
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <b-link class="nav-link" :active="showWebinars"  @click.prevent="toggle">Webinars ({{cntWebinars}})</b-link>
              </li>
              <li class="nav-item">
                <b-link class="nav-link" :active="!showWebinars" @click.prevent="toggle">Podcasts ({{cntPodcasts}})</b-link>
              </li>
              <!-- <li class="nav-item">
                <a class="nav-link" href="#">Link</a>
              </li>
              <li class="nav-item">
                <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
              </li> -->
            </ul>
            <div class="div-section-body pb-2">
              <completed-webinar v-if="showWebinars && cntWebinars !== 0"></completed-webinar>
              <completed-podcast v-if="!showWebinars && cntPodcasts !== 0"></completed-podcast>
            </div>
          </div>

      </b-col>
    </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils";

import CompletedWebinar from '@/components/CompletedWebinar'
import CompletedPodcast from '@/components/CompletedPodcast'

export default {
  name: "Completed",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      loading: true,
      studentHash: this.$root.getToken(),
      title: "CE Completed",
      blurb: "",
      showWebinars: true,
      cntWebinars: 0,
      cntPodcasts: 0,
    }
  },
  props: {  },
  computed: {
    totalRows() {
      return this.cntWebinars + this.cntPodcasts
    }
   },
  components: {
    'completed-webinar': CompletedWebinar,
    'completed-podcast': CompletedPodcast
  },
  methods: {
    toggle() {
      this.showWebinars = !this.showWebinars
    },
    doCompleted() {
      this.loading = true
      this.classes = []
      service
        .getCompleted(this.studentHash)
        .then(res => {
          if (this.debug) console.log(res)
          if (res.status && res.rowCount !== 0) {
            // this.blurb = `Completed: ${res.rowCount}`
            this.cntWebinars = res.data[0].cntWebinars
            this.cntPodcasts = res.data[0].cntPodcasts
          } else {
            this.error = true
            this.errorMsg = "API Error.  Unable to retrieve data."
          }
        })
        .finally(() => this.loading = false)
        .catch(e => {
          console.log(e)
          this.error = true
          this.errorMsg = "System Error.  Unable to retrieve data."
        })
    }
  },
  created() {
    this.loading = true
    this.showWebinars = true
    this.errors = false
    // console.log(`page: ${this.page}  h: ${this.studentHash}`)
    this.doCompleted()
  },
  mounted() {
    // console.log('mounted')
  },
  beforeDestroy() {
    // console.log('destroy')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Completed.vue